import React from 'react';
import './index.module.less';

interface IProps {
  item: any;
  onSelect: (item : any, isSearch?: boolean) => void;
  selectItem: any;
}

const Item = (props: IProps) => {
  const { item, onSelect, selectItem } = props;
  const { uniqueId, title, address } = item;

  const select = () => {
    onSelect && onSelect(item);
  }
  const isSelect = selectItem && selectItem.uniqueId === uniqueId;
  const distance = item.distance >= 1000 ? (item.distance / 1000).toFixed(2) + 'km' : (item.distance).toFixed(2)+ 'm'
  return (
    <div styleName="item" onClick={ select }>
      <div styleName="item-name" className="flex">
        <span styleName="item-name-text" >{ title || '' }</span>
        {
          isSelect ?  <i className="iconfont icon-chenggong" styleName="icon-checked" /> : null
        }
      </div>
      <div styleName="item-address">
      {
        item.distance > 0 ? (
          <span styleName="item-name-distance">{ distance }｜</span>
        ) : null
      }
      { address || title || '' }
      </div>
    </div>
  )
}

export default Item;